import { Filmomtale, Genre } from "@filmweb/sanity-types";
import classNames from "classnames";
import SNoPoster from "components/NoPoster";
import CMSImage from "components/images/Image";
import SFacts from "components/program/SFacts";
import SKinoklubbTicket from "components/program/SKinoklubbTicket";
import SShowsContainer from "components/program/SShowsContainer";
import STicketButton from "components/program/STicketButton";
import isKinoklubb from "lib/isKinoklubb";
import { IFilm } from "lib/types/Program";
import { IMovieArticle, getFilmUrlFromEdi } from "lib/types/sanity";
import Link from "next/link";
import styles from "./MoviePosterRow.module.css";


//#region [Props]
type MovieProps = {
    movie: IFilm;
    filmwebMovie?: Filmomtale;
    allowTitleOverride?: boolean;
    localMovie?: IMovieArticle;
};
//#endregion

//#region [Component]
export default function MoviePosterRow({ movie, filmwebMovie, allowTitleOverride, localMovie }: MovieProps) {
    const poster = filmwebMovie?.mainPosterV2 ?? filmwebMovie?.postersV2?.[0];
    let title: string = movie.title;
    if (allowTitleOverride && localMovie?.titleOverride) {
        title = localMovie.titleOverride;
    }

    return <article className={styles.SMovie}>
        {!filmwebMovie && <p>Mangler filmomtale fra Filmweb! ({movie.mainVersionId} - {movie.title})</p>}
        {filmwebMovie && <>
            <Link href={getFilmUrlFromEdi(movie.mainVersionId)} passHref legacyBehavior>
                <a className={classNames(styles.SPosterContainer, isKinoklubb(filmwebMovie) ? styles.isKinoklubb : null)} aria-label={movie.title}>
                    {poster && <CMSImage className={styles.SPoster} image={poster} isFilmweb width={150} altText={`Plakat for '${filmwebMovie.title}'`} />}
                    {!poster && <SNoPoster />}
                </a>
            </Link>
            <div className={styles.STextContainer}>
                <Link href={getFilmUrlFromEdi(movie.mainVersionId)}>
                    <h1 className={styles.SMovieTitle}>{title}</h1>
                </Link>
                <SFacts>
                    {(filmwebMovie?.genres?.length ?? 0) !== 0 && <li className="genre" title="Sjangre">{filmwebMovie?.genres?.map(g => (g as Genre).name).join(" / ")}</li>}
                    {filmwebMovie?.runningTime && <li title="Spilletid">{filmwebMovie?.runningTime}</li>}
                    {filmwebMovie?.ageRating?.age && <li title="Aldersgrense">{filmwebMovie?.ageRating?.age}</li>}
                </SFacts>
                <SShowsContainer>
                    {movie.shows?.map(show => <STicketButton key={`${show.movieMainVersionId}|${show.showStart}|${show.screenName}`} show={show} showPassed showDate appendShowType />)}
                    {isKinoklubb(filmwebMovie) && <SKinoklubbTicket />}
                </SShowsContainer>
            </div>
        </>}
    </article>
}

//#endregion